export default __webpack_public_path__ + "static/media/amex.4115ef78.svg";